import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPC_CHANNEL } from '../../_offline/electron.constants';
import { CurrentUserSchema } from '../../_offline/models/current-user.schema';
import { DatabaseBaseService } from '../base/database-base.service';
import { LoginUserOfflineService } from '../offline/login-user-offline.service';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class CurrentUserDbService extends DatabaseBaseService {

  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  get(): Observable<CurrentUserSchema>  {
    return this.ipcSendSync(IPC_CHANNEL.CURRENT_USER.GET, IPC_CHANNEL.CURRENT_USER.ID);
  }

  put(currentUser: CurrentUserSchema): Observable<CurrentUserSchema> {
    return this.ipcSendSync(IPC_CHANNEL.CURRENT_USER.PUT, currentUser);
  }
}
